import { debounce } from './events';

export default class ParallaxBehaviour {
  #element: HTMLElement;
  #percentage: number;
  #initialTransformValue: string;

  constructor(element: HTMLElement, percentage: number) {
    this.#element = element;
    this.#initialTransformValue = window.getComputedStyle(this.#element).transform;
    this.#percentage = percentage / 100;

    this.#addEventListeners();
    this.#updatePosition();
  }

  #addEventListeners() {
    window.addEventListener('resize', debounce(() => {
      this.#revalidate();
      this.#updatePosition();
    }, 10));
    window.addEventListener('scroll', debounce(() => this.#updatePosition(), 10));
  }

  #revalidate() {
    this.#element.style.removeProperty('transform');
    this.#initialTransformValue = window.getComputedStyle(this.#element).transform;
  }

  #updatePosition() {
    this.#element.style.removeProperty('transform');
    const elementPosition = (this.#element.getBoundingClientRect().top - (window.innerHeight / 2)) + (this.#element.clientHeight / 2);
    
    this.#element.style.transform = `${this.#initialTransformValue != 'none' ? this.#initialTransformValue : ''} translateY(${elementPosition * this.#percentage}%)`;
  }
}